import { FilterBase } from './FilterBase';


export class FilterAdminMission extends FilterBase {
        
    public ownerIds:Array<number>
    public gliderIds:Array<number>
    public onGoing:boolean
    public simulated:boolean

    constructor({ownerIds = [] as Array<number>,gliderIds = [] as Array<number>,onGoing = false,simulated = false,...args} = {}) { 
        super(args)       
        this.ownerIds = ownerIds
        this.gliderIds = gliderIds
        this.onGoing = onGoing
        this.simulated = simulated
    }
}
